var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldFrame = function SvgGoldFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goldFrame_svg__a)",
    fillRule: "evenodd",
    d: "M33.5 16.866a3 3 0 0 0-3 0L5.787 31.134a3 3 0 0 0-1.5 2.598v28.536a3 3 0 0 0 1.5 2.598L30.5 79.134a3 3 0 0 0 3 0l24.713-14.268a3 3 0 0 0 1.5-2.598V33.732a3 3 0 0 0-1.5-2.598zm0 6.358a3 3 0 0 0-3 0L11.293 34.313a3 3 0 0 0-1.5 2.598v22.178a3 3 0 0 0 1.5 2.598L30.5 72.777a3 3 0 0 0 3 0l19.207-11.09a3 3 0 0 0 1.5-2.598V36.911a3 3 0 0 0-1.5-2.598z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goldFrame_svg__b)",
    stroke: "url(#goldFrame_svg__c)",
    strokeWidth: 4,
    d: "m23.012 11.11.001-.005zm.613-.811q-.227-.09-.419-.161l.613-3.065 1.786 2.38-.162.181-.303.34c-.341.385-.948.546-1.515.325Zm2.538-.102-.004-.004z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goldFrame_svg__d)",
    stroke: "url(#goldFrame_svg__e)",
    strokeWidth: 4,
    d: "m37.838 10.197.002-.004zm.755-.53-.197-.214 1.785-2.38.617 3.088-.366.139c-.589.226-1.204.062-1.55-.316q-.158-.175-.29-.316Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#goldFrame_svg__f)",
    fillRule: "evenodd",
    d: "M45.595 7.203c.662-.491 1.58.122 1.376.922L44.66 17.22c-.059.23-.193.434-.382.579l-.255.196a.74.74 0 0 0-.13 1.05c.145.181.196.42.14.645l-.636 2.496a.88.88 0 0 1-.851.662H21.454a.88.88 0 0 1-.852-.662l-.618-2.434a.63.63 0 0 1 .247-.667.626.626 0 0 0-.036-1.05l-.429-.258a.95.95 0 0 1-.432-.58L17.03 8.124c-.203-.799.713-1.414 1.376-.922l3.578 2.661a3 3 0 0 0 4.395-.918l4.86-8.504A.87.87 0 0 1 32 0c.297 0 .594.148.762.442l4.86 8.504a3 3 0 0 0 4.394.918z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECBB3F",
    d: "m35.39 13.608-2.637-4.394a.87.87 0 0 0-.752-.427.87.87 0 0 0-.754.427l-2.637 4.394a.88.88 0 0 0 0 .904l2.637 4.394a.87.87 0 0 0 .754.427.87.87 0 0 0 .752-.427l2.637-4.394a.88.88 0 0 0 0-.904"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldFrame_svg__a",
    x1: 32,
    x2: 32,
    y1: 16.742,
    y2: 78.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA7606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldFrame_svg__b",
    x1: 24.492,
    x2: 24.492,
    y1: 12.687,
    y2: 3.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldFrame_svg__c",
    x1: 24.492,
    x2: 24.492,
    y1: 13.124,
    y2: 3.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDAC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldFrame_svg__d",
    x1: 39.507,
    x2: 39.507,
    y1: 12.687,
    y2: 3.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldFrame_svg__e",
    x1: 39.507,
    x2: 39.507,
    y1: 13.124,
    y2: 3.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDAC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldFrame_svg__f",
    x1: 32,
    x2: 32,
    y1: 22.848,
    y2: 0.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE69D"
  })))));
};
export default SvgGoldFrame;